import { render, staticRenderFns } from "./TopMenuItem.vue?vue&type=template&id=7ab46f98&scoped=true&"
import script from "./TopMenuItem.vue?vue&type=script&lang=js&"
export * from "./TopMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TopMenuItem.vue?vue&type=style&index=0&id=7ab46f98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab46f98",
  null
  
)

export default component.exports